<template>
  <b-overlay
    id="overlay-background"
    :show="loader"
    variant="dark"
    opacity="0.85"
    blur="2px"
    rounded="sm"
    spinner-variant="primary"
    spinner-medium
  >
    <b-row>
      <b-col
        md="8"
        lg="8"
        offset-lg="2"
      >
        <b-card
          no-body
          class="card-payment"
        >
          <b-card-body>
            <!-- form -->
            <b-form>
              <validation-observer
                ref="settingsform"
                tag="form"
              >
                <b-row>
                  <b-col sm="12">
                    <validation-provider
                      #default="{ errors }"
                      name="Module"
                      rules="required"
                    >
                      <b-form-group
                        label="Module"
                        label-for="module"
                      >
                        <v-select
                          id="module"
                          v-model="selected"
                          :options="moduleOptions"
                          label="module"
                        />
                        <small class="text-danger">{{ errors[0] }}</small>
                      </b-form-group>
                    </validation-provider>
                  </b-col>
                  <b-col sm="12">
                    <validation-provider
                      #default="{ errors }"
                      name="Client Id"
                      rules="required"
                    >
                      <b-form-group
                        label="Client Id"
                        label-for="client_id"
                      >
                        <b-form-input
                          id="client_id"
                          v-model="setting_values.client_id"
                          type="text"
                          :placeholder="$t('DEBTIA_CLIENT_ID')"
                          :maxlength="maxClientIdLength"
                        />
                        <small class="text-danger">{{ errors[0] }}</small>
                      </b-form-group>
                    </validation-provider>
                  </b-col>
                  <b-col sm="12">
                    <b-form-group
                      :label="$t('DEBTIA_SECRET')"
                      label-for="secret"
                      class="mb-2"
                    >
                      <validation-provider
                        #default="{ errors }"
                        name="Secret"
                        rules="required"
                      >
                        <b-form-input
                          id="secret"
                          v-model="setting_values.secret"
                          type="text"
                          :placeholder="$t('DEBTIA_SECRET')"
                          :maxlength="maxSecretLength"
                        />
                        <small class="text-danger">{{ errors[0] }}</small>
                      </validation-provider>
                    </b-form-group>
                  </b-col>
                </b-row>
              </validation-observer>
              <b-button
                v-ripple.400="'rgba(255, 255, 255, 0.15)'"
                block
                variant="primary"
                @click="postSettingValues"
              >
                Save
              </b-button>
            </b-form>
          <!--/ form -->
          </b-card-body>
        </b-card>
      </b-col>
    </b-row>
  </b-overlay>
</template>

<script>
import {
  BCard, BOverlay, BCardBody, BRow, BCol, BFormGroup, BFormInput, BButton, BForm,
} from 'bootstrap-vue'
import vSelect from 'vue-select'
import Ripple from 'vue-ripple-directive'
import { ValidationProvider, ValidationObserver } from 'vee-validate'
import { required } from '@validations'
import axios from '@axios'

export default {
  components: {
    ValidationProvider,
    ValidationObserver,
    BCard,
    BOverlay,
    BCardBody,
    BRow,
    BCol,
    BForm,
    BFormGroup,
    BFormInput,
    vSelect,
    BButton,
  },
  directives: {
    Ripple,
  },
  data() {
    return {
      loader: false,
      setting_values: {
        id: '',
        module: '',
        client_id: '',
        secret: '',
      },
      newValue: 'debt-cases',
      selected: 'debt-cases',
      moduleOptions: ['debt-cases', 'communication', 'physical-letters'],
      required,
      maxClientIdLength: 20,
      maxSecretLength: 40,
    }
  },
  watch: {
    selected: {
      deep: true,
      handler(newValue) {
        console.log('Selected users changed', newValue)
        this.settingsData(newValue)
      },
    },
    role: {
      handler(selected) {
        this.settingsData(selected)
      },
    },
  },
  created() {
    this.settingsData('debt-cases')
  },
  methods: {
    makeSuccessToast() {
      this.$bvToast.toast('Settings have been successfully updated', {
        title: 'Success',
        variant: 'success',
        solid: false,
      })
    },
    makeFailureToast(error) {
      this.loader = false
      this.$bvToast.toast(error.response.data.message, {
        title: 'Failed',
        variant: 'danger',
        solid: false,
      })
    },
    settingsData(selected) {
      this.loader = true
      axios.get('user-settings/get', { params: { module: selected } }).then(response => {
        const settingValues = this.setting_values
        const settingDetails = response.data.data
        if (settingDetails === null) {
          settingValues.id = ''
          settingValues.module = ''
          settingValues.client_id = ''
          settingValues.secret = ''
        } else {
          settingValues.id = settingDetails.id
          settingValues.module = settingDetails.module
          settingValues.client_id = settingDetails.client_id
          settingValues.secret = settingDetails.secret
        }
        this.loader = false
      })
    },
    postSettingValues() {
      return new Promise((resolve, reject) => {
        this.$refs.settingsform.validate().then(success => {
          if (success) {
            this.loader = true
            this.setting_values.company_id = JSON.parse(localStorage.getItem('userData')).data.id
            this.setting_values.module = this.selected
            axios.post('user-settings/save', { ...this.setting_values }).then(response => {
              console.log(response)
              this.loader = false
              this.makeSuccessToast()
              resolve(true)
            }).catch(error => {
              // if (err.response.data.message) {
              //   this.alertErrors.push(err.response.data.message)
              // }
              this.makeFailureToast(error)
              resolve(true)
            })
          } else {
            reject()
          }
        })
      })
    },
  },
}
</script>

<style lang="scss">
@import '@core/scss/vue/libs/vue-select.scss';
</style>
